import React, { useCallback, useMemo } from "react";
import { Caption, Title } from "./Texts";
import { Grid, TextField } from "@mui/material";
import { TypeSollicitation } from "../../../core/apis/monsisra/generated";
import { useAppDispatch, useAppSelector } from "../../store";
import { setPreferencesPartial } from "../../store/expertise/expertise.reducer";
import { TypeSollicitationCtx } from "../../../index";

const strings = (type: TypeSollicitation) => ({
	title: "Description de mon activité (obligatoire)",
	description:
		type === TypeSollicitation.TeleExpertise
			? "Décrire ici votre activité d'expert, afin d'orienter au mieux les demandeurs. Ces informations apparaîtrons dans les résultats de recherche dans l'outil MonSisra"
			: "Décrire ici vos activités d'équipe ressource, afin d'orienter au mieux les demandeurs. Ces informations apparaîtrons dans les résultats de recherche dans l'outil MonSisra",
	inputPlaceHolder: "Champ limité a 800 caractères",
});

function DescriptionActivite() {
	const typeSollicitation = React.useContext(TypeSollicitationCtx);

	const str = useMemo(() => strings(typeSollicitation), [typeSollicitation]);

	const dispatch = useAppDispatch();

	const { preferences } = useAppSelector((s) => s.expertise);

	const setDescription = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			let description = e.target.value;
			dispatch(
				setPreferencesPartial({
					description: description,
				})
			);
		},
		[dispatch]
	);

	if (!preferences) return null;

	return (
		<Grid component={"section"} container direction={"column"} spacing={2}>
			<Grid item>
				<Title text={str.title} />
			</Grid>
			<Grid item>
				<Caption text={str.description} />
			</Grid>
			<Grid item>
				<TextField
					className={"input"}
					error={preferences.description?.length === 0}
					fullWidth
					placeholder={str.inputPlaceHolder}
					multiline
					onChange={setDescription}
					value={preferences.description}
					rows={4}
					inputProps={{
						maxLength: "800",
					}}
				/>
			</Grid>
		</Grid>
	);
}

export default DescriptionActivite;
